import { useNotify } from '@/app/providers/notify';
import { tryCatchDecorate } from '@/shared/lib';
import { getErrorMessageTyped } from '@/shared/services';
import type {
  Agreement,
  PreparedAgreement,
} from '@/types/Agreements';
import type { TableHeading } from '@/types/Table';

import type { Step } from './types';

type StoreAction = (...args: Array<never>) => unknown;

export const documentErrorMessage = 'Не удалось получить документ';
export const organisationErrorMessage = 'Не удалось получить данные организации';

export const defaultSteps: Array<Step> = [
  {
    component: 'CreateContract',
    label: 'Данные об организации',
  },
  {
    component: 'ChooseComplex',
    label: 'Выбор ЖК',
  },
  {
    component: 'ChooseType',
    label: 'Выбор типа договора',
  },
  {
    component: 'ContractList',
    label: 'Договоры',
  },
];

export const contractHeadingList: Array<TableHeading> = [
  {
    movable: false,
    label: 'Проект',
    hint: '',
  },
  {
    movable: false,
    label: 'Тип договора',
    hint: '',
  },
  {
    movable: false,
    label: 'Агентство',
    hint: '',
  },
  {
    movable: false,
    label: 'Дата создания',
    hint: '',
  },
];

export function notifyRethrowDecorate<TFn extends StoreAction> (fn: TFn, fallbackMessage?: string): TFn {
  return tryCatchDecorate(fn, (error: unknown) => {
    const notifier = useNotify();

    notifier?.create({
      message: getErrorMessageTyped(error, fallbackMessage),
      type: 'negative',
    });

    throw error;
  });
}

export function preparedContracts (items: Array<Agreement>): Array<PreparedAgreement> {
  return items.map((item) => {
    const {
      slug,
      files,
    } = item.files[0] ?? {};

    return {
      ...item,
      documentType: slug,
      files,
    };
  });
}
